import React, { useEffect, useState } from "react";

/**
 * Common App / Event Loader
 * @param {boolean} isLoading - Controls loader visibility
 * @param {string} [text] - Optional loading message text
 * @param {string} [primaryColor] - Custom hex/RGB primary color
 */
export default function CommonLoader({
  isLoading = true,
  text = "Loading, please wait...",
}) {
  const [activeColor, setActiveColor] = useState("#02a9e0"); // Fallback color

  useEffect(() => {
    // Auto-detect dynamic primary color set in your CSS variable (--color-primary)
    const computedColor = getComputedStyle(document.documentElement)
      .getPropertyValue("--color-primary")
      .trim();

    if (computedColor) {
      setActiveColor(computedColor);
    }
  }, []);

  if (!isLoading) return null;

  return (
    <div className="fixed inset-0 z-[99999] flex flex-col items-center justify-center bg-white/80 backdrop-blur-sm transition-all duration-300 dark:bg-navy-900/80">
      <div className="relative flex flex-col items-center justify-center p-6 text-center">
        {/* Soft Background Radial Glow */}
        <div
          className="absolute h-28 w-28 rounded-full blur-2xl opacity-25 animate-pulse transition-colors duration-300"
          style={{ backgroundColor: activeColor }}
        />

        {/* Loader Ring & Core */}
        <div className="relative flex h-20 w-20 items-center justify-center rounded-full bg-white shadow-lg dark:bg-navy-800">
          {/* Animated Spinner Ring */}
          <div
            className="absolute inset-0 h-full w-full animate-spin rounded-full border-4 border-transparent border-t-current"
            style={{ color: activeColor }}
          />

          {/* Center Pulse Core */}
          <div
            className="h-6 w-6 rounded-full animate-ping opacity-75"
            style={{ backgroundColor: activeColor }}
          />
        </div>

        {/* Loading Message */}
        {text && (
          <p
            className="mt-5 text-sm font-semibold tracking-wide animate-pulse transition-colors duration-300"
            style={{ color: activeColor }}
          >
            {text}
          </p>
        )}
      </div>
    </div>
  );
}